/* Convert only fully understood measurement text; preserve the source otherwise. */
function parseAnthemMeasurements(text) {
  const source = text.replace(/\u00a0|\u3000/g, ' ').trim();
  const headers = [...source.matchAll(/(?:\bsize|サイズ)\s*[:：]?\s*([a-z0-9]+)\s*[:：/／]/gi)];
  if (!headers.length || source.slice(0, headers[0].index).trim()) return null;
  const sizes = [];
  const labels = new Map();
  for (let index = 0; index < headers.length; index++) {
    const header = headers[index];
    const body = source.slice(header.index + header[0].length, headers[index + 1]?.index ?? source.length);
    const pattern = /([\p{L}\d][\p{L}\p{M}\d ()（）/／&＆.・-]*?)\s*[:：]\s*(\d+(?:\.\d+)?(?:\s*(?:cm\s*)?[-–—〜～~]\s*\d+(?:\.\d+)?)?)\s*(?:cm|㎝|ｃｍ)(?![a-z])/giu;
    const values = new Map();
    let consumed = 0;
    for (const match of body.matchAll(pattern)) {
      if (body.slice(consumed, match.index).replace(/[\s,，;；|｜/／]+/g, '')) return null;
      const label = match[1].trim().replace(/\s+/g, ' ');
      const key = label.toLowerCase();
      if (values.has(key)) return null;
      labels.set(key, labels.get(key) || label);
      values.set(key, match[2]);
      consumed = match.index + match[0].length;
    }
    if (!values.size || body.slice(consumed).replace(/[\s,，;；|｜/／]+/g, '')) return null;
    const size = header[1];
    if (sizes.some(row => row.size.toLowerCase() === size.toLowerCase())) return null;
    sizes.push({ size, values });
  }
  return { sizes, labels };
}

if (typeof customElements !== 'undefined' && !customElements.get('anthem-size-chart')) {
  customElements.define('anthem-size-chart', class extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('table')) return;
      const source = this.querySelector('[data-size-source]');
      const data = source && parseAnthemMeasurements(source.textContent);
      if (!data) return;
      const table = document.createElement('table');
      table.className = 'anthem-size-chart__table';
      const caption = table.createCaption();
      caption.className = 'visually-hidden';
      caption.textContent = this.dataset.caption;
      const head = table.createTHead().insertRow();
      const body = table.createTBody();
      const cell = (row, text, heading = false, scope = 'col') => {
        const element = document.createElement(heading ? 'th' : 'td');
        if (heading) element.scope = scope;
        element.textContent = text;
        row.append(element);
      };
      const measurement = value => value == null ? '—' : `${value}cm`;
      cell(head, this.dataset.sizeLabel || 'SIZE', true);
      if (data.sizes.length === 1) {
        for (const label of data.labels.values()) cell(head, label, true);
        const row = body.insertRow();
        cell(row, data.sizes[0].size, true, 'row');
        for (const key of data.labels.keys()) cell(row, measurement(data.sizes[0].values.get(key)));
      } else {
        for (const size of data.sizes) cell(head, size.size, true);
        for (const [key, label] of data.labels) {
          const row = body.insertRow();
          cell(row, label, true, 'row');
          for (const size of data.sizes) cell(row, measurement(size.values.get(key)));
        }
      }
      const scroll = document.createElement('div');
      scroll.className = 'anthem-size-chart__scroll';
      scroll.tabIndex = 0;
      scroll.setAttribute('role', 'region');
      scroll.setAttribute('aria-label', this.dataset.caption);
      scroll.append(table);
      this.append(scroll);
      source.hidden = true;
    }
  });
}
